<template>
  <div :class="{ 'spacing-experiment-wrapper' : isSpacingEnabled }">
    <template
      v-if="options.length"
      class="label"
    >
      <p
        v-if="selectedName"
        class="label"
        :class="{ 'updated-label' : isSpacingExpEnabledForMcom }"
      >
        {{ label }}: {{ selectedName }}
      </p>
      <p v-else>
        <span
          class="label"
          :class="{ 'updated-label' : isSpacingExpEnabledForMcom }"
        >{{ label }}: </span>Please select
      </p>
    </template>
    <div class="overflow-gutters-row">
      <SelectionTile
        v-slot="{ tile }"
        v-model="selectedId"
        class="margin-top-xxs overflow-gutters-item"
        :options="options"
        cell-spacing="shrink"
        size-tile
      >
        <slot :tile="tile" />
      </SelectionTile>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import SelectionTile from '@atomic-ui/selectionTile';
import { useBrand } from '../../composables/useBrand';

const props = defineProps({
  label: {
    type: String,
    default: 'Size',
  },
  modelValue: {
    type: [Array, String, Number],
    default: null,
  },
  options: {
    /** @type import('vue').PropType<SelectionTileOption[]> */
    type: Array,
    default: () => [],
  },
  isSpacingEnabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const { isMcom } = useBrand();

const isSpacingExpEnabledForMcom = isMcom && props.isSpacingEnabled;

const selectedId = computed({
  get() {
    return props.modelValue;
  },
  set(newVal) {
    emit('update:modelValue', newVal);
  },
});

const selectedName = computed(() => props.options.find((option) => option.id === selectedId.value)?.text || '');

</script>

<style lang="scss" scoped>
.spacing-experiment-wrapper {
  .updated-label {
    font-weight: 400;
    text-transform: inherit;
  }

  :deep() {
    .selection-tile.size-tile {
      height: 40px;
    }
  }
}
</style>
